import { useState, useEffect } from 'react';

interface LogoAvatarProps {
  logoUrl: string | null;
  tenantName: string;
  size?: string;
  initialsSize?: string;
  className?: string;
}

export default function LogoAvatar({
  logoUrl,
  tenantName,
  size = 'w-10 h-10',
  initialsSize = 'text-sm',
  className = '',
}: LogoAvatarProps) {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [logoUrl]);

  const initials = tenantName
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const showImage = logoUrl && !imgError;

  return (
    <div
      className={`${size} rounded-full overflow-hidden flex items-center justify-center ${className}`}
    >
      {showImage ? (
        <img
          src={logoUrl}
          alt={tenantName}
          className="w-full h-full object-cover"
          onError={() => setImgError(true)}
        />
      ) : (
        <span className={`${initialsSize} font-bold text-primary`}>
          {initials}
        </span>
      )}
    </div>
  );
}
